import React, { useEffect } from "react";
import "./divisionTable.css";
import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { customerDeleteDivision } from "../../../redux/actions/customerActions";
import ChangeSaved from "../../../components/popups/ChangeSaved";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import DeleteBtn from "../../../components/buttons/deleteBtn";
import DeleteModal from "../../../components/modals/deleteModal";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    maxWidth: "45rem",
    minHeight: "10rem",
    overflowY: "auto",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const DivisionTable = ({ maxWidth = "60rem", headQuaters, vendor_type }) => {
  const dispatch = useDispatch();
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [deleteItem, setDeleteItem] = useState("");

  const [total, setTotal] = useState(0);
  useEffect(() => {
    let total = 0;
    headQuaters?.forEach((ex) => {
      total += 1;
    });
    setTotal(total);
  }, [headQuaters]);

  const onDelete = (id) => {
    dispatch(
      customerDeleteDivision(
        {
          id: id,
          vendor_type: vendor_type,
        },
        onSuccess,
        onError
      )
    );
  };
  const timeOutFnc = () => {
    onSetSuccessShow(false);
    window.location.reload();
  };

  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  return (
    <div className="">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table text-nowrap overflow-scroll">
          <tr className="table-rows">
            <th className="table-heads" width={"5%"}>
              Division ID
            </th>
            <th className="table-heads" width={"10%"}>
              Division Name
            </th>
            <th className="table-heads" width={"10%"}>
              Field Force User
            </th>
            <th className="table-heads" width={"10%"}>
              Action
            </th>
          </tr>
          {headQuaters?.map((ele, index) => {
            return (
              <tr className="table-rows1" index={index}>
                <td className="table-each-row-data">
                  {ele?.vendorDivision?.code}
                </td>
                <td className="table-each-row-data">
                  {ele?.vendorDivision?.name}
                </td>
                <td className="table-each-row-data">
                  {ele?.fieldForceUser?.name}
                </td>

                <td className="table-each-row-data">
                  <button
                    className={`button-disable`}
                    type="button"
                    color={"green"}
                    onClick={() => {
                      setDeleteItem(ele.id);
                      setShowDeletePopup(true);
                    }}
                  >
                    delete
                  </button>
                </td>
              </tr>
            );
          })}
        </table>
      </TableContainer>
      <TableFooter
        className="d-flex justify-content-between align-items-center px-4 table-footer"
        maxWidth={maxWidth}
      >
        <div>
          <label className="text-white ">Total</label>
        </div>
        <div>
          <label className="text-white fw_600 mx-5">{total}</label>
        </div>
      </TableFooter>
      <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <DeleteModal
        show={showDeletePopup}
        title={""}
        handleClose={() => {
          setShowDeletePopup(false);
          setDeleteItem("");
        }}
        delFunc={() => {
          if (deleteItem != "") {
            onDelete(deleteItem);
          }
        }}
      />
    </div>
  );
};

export default DivisionTable;
